import * as React from 'react';
import { Title } from 'react-admin';
import AdminPlayerCard from '../components/AdminPlayerCard';
import { BASE_URL } from '../BASE_CONSTS';
import Cookies from '../provider/helpers/Cookies';
import { buildDashboardPlayers } from '../custom/playerViewModel';
import { fetchAllFootballers, isPlayerActive } from '../custom/dashboardData';

const Dashboard = () => {
  const [players, setPlayers] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    const token = Cookies.getCookie('token');
    let cancelled = false;
    setLoading(true);

    fetchAllFootballers({ baseUrl: BASE_URL, token })
      .then((data) => {
        if (cancelled) return;
        setPlayers(buildDashboardPlayers(data));
        setError('');
      })
      .catch((fetchError) => {
        if (!cancelled) setError(`Не удалось загрузить футболистов: ${fetchError.message}`);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const activeCount = players.filter((player) => isPlayerActive(player.Active)).length;

  return (
    <main className="fs-dashboard">
      <Title title="Главная" />
      <header className="fs-page-hero">
        <div>
          <span className="fs-page-kicker">FOOTSKILL ADMIN</span>
          <h1>Футболисты</h1>
          <p>Карточки игроков, лучшие результаты и быстрый переход к редактированию.</p>
        </div>
        <div className="fs-dashboard-summary">
          <div><strong>{players.length}</strong><span>Всего игроков</span></div>
          <div><strong>{activeCount}</strong><span>Активных</span></div>
        </div>
      </header>

      {loading ? <div className="fs-admin-empty">Загрузка футболистов…</div> : null}
      {error ? <div className="fs-admin-alert fs-admin-alert--error">{error}</div> : null}
      {!loading && !error && players.length === 0 ? <div className="fs-admin-empty">Футболистов пока нет.</div> : null}

      <section className="fs-dashboard-grid">
        {players.map((player) => <AdminPlayerCard key={player.id} player={player} />)}
      </section>
    </main>
  );
};

export default Dashboard;
